import { Srfc } from './srfc'

const srfc = new Srfc()
srfc.init()

export default srfc
